import TransactionsAbi from "./Transactions.json";
import SupplyChainAbi from "./supplyChain.json";
import NFTAbi from "./NFT.json";

export const contractAddress = "0xB0a9aDb3302C778a24846df478C9bc701F8e4C51";
export const contractABI = TransactionsAbi.abi;

export const supplyChainAddress = "0xC8fea2c9c38BFf33Cd311A713dEfc5DB632d7C60";
export const supplyChainABI = SupplyChainAbi.abi;

export const NFTAddress = "0xEC5551E8e37fA60a209f26018d1db1e35ad4AdC3";
export const NFTABI = NFTAbi.abi;
